import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogHeaderComponent } from '../dialog-header/dialog-header.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';
import { NewActionButtonComponent } from '../new-action-button/new-action-button.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { LucideIconData } from 'node_modules/lucide-angular/icons/types';
import { StatusIcons } from 'src/models/global-interfaces';

export interface DialogButtonPayload {
  checked?: boolean;
  selectedOption?: number;
  textInput?: string;
}

export interface DialogButtonConfig<> {
  text: string;
  icon?: LucideIconData;
  theme: string;
  testId?: string;
  /**
   * Returning true will close the dialog, false will keep it open
   * @param payload
   * @returns
   */
  action: (payload: DialogButtonPayload) => boolean;
}

export interface DialogData {
  title: string;
  content: DialogContent[];
  buttons: DialogButtonConfig[];
  checkBox?: boolean;
  radioOptions?: string[];
  setDefaultRadioOption?: boolean;
  textInput?: boolean;
  textInputPlaceholder?: string;
  onXClick?: () => void;
}

export interface DialogContent {
  scope?: string;
  title?: string;
  message?: string;
}

@Component({
  selector: 'app-dialog',
  imports: [
    MatDialogModule,
    DialogHeaderComponent,
    MatCheckbox,
    FormsModule,
    LucideAngularModule,
    NewActionButtonComponent,
    MatRadioModule,
    MatFormFieldModule,
  ],
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogComponent {
  private readonly dialogRef = inject(MatDialogRef<DialogComponent>);
  protected readonly data = inject(MAT_DIALOG_DATA);
  protected icons = StatusIcons;
  protected checked = false;
  protected inputValue!: string;
  protected selectedOption!: number;

  constructor() {
    if (this.data.radioOptions && this.data.setDefaultRadioOption) {
      this.selectedOption = 1;
    }
  }

  protected closeDialog() {
    if (this.data.onXClick) {
      this.data.onXClick();
      this.dialogRef.close();
    } else {
      this.dialogRef.close();
    }
  }

  protected action(buttonAction: (payload: DialogButtonPayload) => boolean) {
    if (
      buttonAction({
        checked: this.checked,
        selectedOption: this.selectedOption,
        textInput: this.inputValue,
      })
    ) {
      this.dialogRef.close();
    }
  }
}
